import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';

import data from './goldmedalistsinfo.json';
import goldData from './golds.json';
import './dataviz.scss';
import Tooltip from './Tooltip';
import ImageScroll from './ImagesScroll';


const RetirementYears = () => {
  const svgRef = useRef();
  const containerRef = useRef();

  const [tooltipContent, setTooltipContent] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    drawChart();

    const handleResize = () => {
        drawChart();
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
        d3.select(svgRef.current).selectAll('*').remove();
    };
}, []);
  
  const drawChart = () => {
    const container = d3.select(containerRef.current);
    const svg = d3.select(svgRef.current);
    const containerWidth = container.node().clientWidth;
    const containerHeight = container.node().clientHeight;

    

    const margin = { top: 20, right: 0, bottom: 40, left: 35 };
    const width = containerWidth - margin.left - margin.right;
    const height = containerHeight - margin.top - margin.bottom;

    svg
      .attr('viewBox', `0 0 ${containerWidth} ${containerHeight}`)
      .attr('preserveAspectRatio', 'xMinYMid')
      .attr('width', '100%')
      .attr('height', '100%');

    const svgGroup = svg
      .selectAll('g')
      .data([null])
      .join('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

      svgGroup.selectAll('*').remove();

    const filterActive = data.filter(d => d.retirementYear !== '现役' && d.sw !== 'Winter');


    const retirementCount = d3.rollups(
        filterActive,
      v => v.length,
      d => d.retirementYear
    ).map(([year, count]) => ({ year, count }));

    const years = d3.range(1984, 2024);

    years.forEach(year => {
        const found = retirementCount.find(item => item.year === year);
        if (!found) {
          retirementCount.push({ year, count: 0 });
        }
      });

    retirementCount.sort((a, b) => a.year - b.year);

    const goldsSummer = goldData.filter(d => d.sw !== 'Winter');

    const goldCounts = d3.rollups(
        goldsSummer,
        v => ({
          count: v.length,
          sw: v[0].sw // Assuming all entries for the same year have the same sw value
        }),
        d => d.year
      ).map(([year, { count, sw }]) => ({ year, count, sw }));

      goldCounts.sort((a, b) => a.year - b.year);

    // const margin = { top: 20, right: 50, bottom: 40, left: 40 };
    // const width = 960 - margin.left - margin.right;
    // const height = 500 - margin.top - margin.bottom;

    // const svg = d3.select(svgRef.current)
    //   .attr('class', '.chart-container')
    //   .attr('width', width + margin.left + margin.right)
    //   .attr('height', height + margin.top + margin.bottom)
    //   .append('g')
    //   .attr("viewBox", `0 0 500 960`)
    //   .attr('transform', `translate(${margin.left},${margin.top})`);

    const x = d3.scaleBand()
      .domain(years)
      .range([0, width])
      .padding(0.1);

    const y1 = d3.scaleLinear()
      .domain([0, d3.max(retirementCount, d => d.count)])
      .nice()
      .range([height, 0]);

    const y2 = d3.scaleLinear()
      .domain([0, d3.max(goldCounts, d => d.count)])
      .nice()
      .range([height, 0]);

    svgGroup.append('g')
      .attr('class', 'grid-lines')
      .selectAll('line')
      .data(x.domain().filter(year => year % 4 === 0))
      .enter().append('line')
      .attr('x1', d => x(d) + x.bandwidth() / 2)
      .attr('x2', d => x(d) + x.bandwidth() / 2)
      .attr('y1', 0)
      .attr('y2', height);

    const xAxis = g => g
      .attr('transform', `translate(0,${height})`)
      .attr('class', 'x-axis')
      .call(d3.axisBottom(x)
        .tickSize(0)
        .tickValues(x.domain().filter(year => year % 4 === 0))
            .tickSizeOuter(0))
      .selectAll('.tick text')
      .attr('dy', '1.5em');

    const yAxisLeft = g => g
      .call(d3.axisLeft(y1).tickSize(0))
      .call(g => g.select('.domain').remove())
      .call(g => g.selectAll('.tick text').attr('transform', 'translate(-10,0)'))
      .attr('class','y-axis');

    const yAxisRight = g => g
      .attr('transform', `translate(${width},0)`)
      .call(d3.axisRight(y2).tickSize(0))
      .call(g => g.select('.domain').remove())
      .call(g => g.selectAll('.tick text').attr('transform', 'translate(10,0)'))
      .attr('class','y-axis');

    
    svgGroup.append('g').call(yAxisLeft);
    svgGroup.append('g').call(yAxisRight);

    svgGroup.selectAll('.bar')
      .data(retirementCount)
      .enter().append('rect')
      .attr('class', 'bar')
      .attr('x', d => x(d.year))
      .attr('y', d => y1(d.count))
      .attr('width', x.bandwidth())
      .attr('height', d => height - y1(d.count))
      .attr('fill', '#9BBBA5')
      .on('mouseover', (event, d) => {
        setTooltipContent(`
          <div class="tooltip__content">
          <span class="tooltip__details"><b>${d.year}年</b></span></br>
          <span class="tooltip__title">${d.count} 位运动员退役</span></div>
          `)
        setTooltipPosition({ x: event.pageX, y: event.pageY })
        setHovered(event.target);
      })
      .on('mouseout', () => {
        setTooltipContent(null);
        setHovered(null);
      })
      ;

      const line = d3.line()
      .x(d => x(d.year) + x.bandwidth() / 2)
      .y(d => y2(d.count));

    svgGroup.append('path')
      .datum(goldCounts)
      .attr('fill', 'none')
      .attr('stroke', '#ECA500')
      .attr('opacity', '0.08')
      .attr('stroke-width', 5)
      .attr('d', line);



    svgGroup.selectAll('.dot')
      .data(goldCounts)
      .enter().append('circle')
      .attr('class', 'dot')
      .attr('cx', d => x(d.year) + x.bandwidth() / 2)
      .attr('cy', d => y2(d.count))
      .attr('r', 6)
      .attr('fill', '#FFDC8A')
      .attr('stroke', '#ECA600')
      .attr('stroke-width', 1)
      .on('mouseover', (event, d) => {
        setTooltipContent(`
          <div class="tooltip__content">
          <span class="tooltip__details"><b>${d.year}年</b></span></br>
          <span class="tooltip__title">${d.count} 枚金牌</span></div>
          `)
        setTooltipPosition({ x: event.pageX, y: event.pageY })
        setHovered(event.target);
      })
      .on('mouseout', () => {
        setTooltipContent(null);
        setHovered(null);
      })
      ;

      svgGroup.append('g').call(xAxis);
      
    // // Y-axis label for retirement count
    //   svgGroup.append('text')
    //   .attr('text-anchor', 'end')
    //   .attr('transform', 'rotate(-90)')
    //   .attr('x', -height / 2)
    //   .attr('y', -margin.left + 20)
    //   .text('Number of Retirements');

    //   // Y-axis label for gold count
    //   svgGroup.append('text')
    //   .attr('text-anchor', 'end')
    //   .attr('transform', 'rotate(-90)')
    //   .attr('x', -height / 2)
    //   .attr('y', width + margin.right - 10)
    //   .text('Number of Gold Medals');


      // return () => {
      //   svgGroup.selectAll('.dot').remove(); 
      // };
  }


  return (
    <div>
      
      <div className='content'>
        <div className='content__text'>
        <h2>四 .奥运会后是夏季奥运冠军退役高峰</h2>
        </div>
      </div>
      <div ref={containerRef} className='chart-container'>

      <div style={{ display:'flex', justifyContent:'space-between' }}>
                <div className='legend__item'>
                  <div className='legend__color' style={{ backgroundColor:'#9BBBA5', marginLeft:'6px' }}></div>
                  <div className='legend__label'>该年奥运冠军退役总数</div>
                  </div>
      
                <div className='legend__item'>
                  
                    <div className='legend__label' style={{ marginRight:'6px' }}>该年中国夏季奥运金牌总数</div><div className='legend__color round' style={{ backgroundColor:'#FFDC8A', border:'1px solid #ECA600' }}></div>
                  </div>
              </div>

        <svg ref={svgRef} id='retirement-years'/>
        <Tooltip content={tooltipContent} position={tooltipPosition} hovered={hovered} />
      </div>

      <div className='content'>
      <div className='scroll__caption chart-caption'>图注：将鼠标悬浮图表，可查看该年奥运冠军退役人数和金牌总数具体信息。</div>

        <div className='content__text'>
        <p>歪脑发现，在夏季奥运会当年和奥运会后的第一年，奥运冠军退役总数有明显的高峰。
        夏季奥运会退役集中的年份和奥运会周期相关。而这一趋势在冬运会中并不显著，这可能与中国冬奥会冠军总数远少于夏季奥运会的有关。</p>

        <p>1949年以来，毛泽东曾多次<a href='https://www.dswxyjy.org.cn/n/2015/1026/c222139-27741712-5.html' target='_blank'>指出</a>，中华民族必须尽快甩掉“东亚病夫”的帽子, 并带头筹备“中华体育总会”，着力发展体育事业。此后，中国在“举国体制”下，“金牌至上”和“功利主义”的思想深入人心。1995年中国体委发布<a href='https://www.dswxyjy.org.cn/n/2015/1026/c222139-27741712-5.html' target='_blank'>《奥运争光计划》</a>中, “以奥运会有希望获奖牌”为主要标准，集中资源发展“<a href='https://www.wainao.me/wainao-reads/Chinese-womens-football-team-out-of-the-world-cup-08222023' target='_blank'>偏门</a>”，也就是相对小众但有很多金牌可拿的项目。这被广泛<a href='https://m.thepaper.cn/newsDetail_forward_13785565' target='_blank'>认为</a>是“田忌赛马”战略，随之而来的是，中国短时间内从“零金牌”到“金牌大国”。运动员们也主动或被动将奥运会视为为国家效力的机会，将奥运会视为自身职业生涯的顶峰。</p>

        <p>而失误和退赛，在相当长的一段时间里，也不能被中国大众所所理解。从第一代“体操王子”  1988汉城奥运会中失力，被<a href='https://www.163.com/dy/article/GH6NT0OS0525CH6S.html' target='_blank'>递刀子</a>，在一片骂声中退役，到2008年北京奥运会中因伤病退赛的刘翔，从“全民偶像”骤降为“<a href='https://www.163.com/dy/article/GEQH4JML05521MK6.html' target='_blank'>刘跑跑</a>”，成为“网暴”对象，中国奥运选手除了竞技本身的压力，还背负了太多塑造中国“体育强国”的重任。据称，李宁曾在接受采访时回忆，“那个年代，人们需要金牌，不需要体育”。但时隔近40年后，今天中国对于“金牌至上”的态度，有改变吗？</p>

        </div>

        <ImageScroll
        src1='/images/AP386704502152.jpg'
        caption1='2012年8月7日，中国选手刘翔在伦敦夏季奥运会田径比赛的男子110米栏预赛中摔倒，靠在跨栏上休息。 (AP / Anja Niedringhaus)'
        src2='/images/AP724311142354.jpg'
        caption2='这张照片拍摄于2015年3月13日星期五，奥运金牌得主、中国人民政治协商会议（CPPCC）委员刘翔抵达北京人民大会堂出席CPPCC闭幕式。 (AP Photo / Ng Han Guan)'
         />

         <div className='content__text'>
          <p>在中国，奥运冠军的头衔，往往会改变一个人的一生。奥运冠军在退役后，大多在体制内有份体面的工作，也实现了户籍的跃迁。奥运会本身，附加给这些中国奥运冠军的意义，非同小可，他们的退役时间，也大多围绕着奥运周期。然而, 每位冠军的身后, 都有成千上万角逐“金牌”的普通运动员。据报道，中国每年约有4000名运动员退役，其中80%面对失业、伤病、贫困等生存问题。没有冠军的荣誉和光环，这些“非奥运冠军”运动员在退役后的命运就显得<a href='http://sports.people.com.cn/GB/31928/357261/' target='_blank'>平淡无奇</a>，他们有的在街头卖艺，在澡堂搓澡，很多人再就业也成为<a href='https://www.sohu.com/a/525943596_209208' target='_blank'>难题</a>。但不要忘记的是，他们与奥运冠军一样，在“举国体制”下，经历多年封闭式的训练，忍受与亲人的分离，背负为国效力的重担，并可能在往后的岁月备受伤病困扰，他们也应得到社会同等的尊重和支持。</p>

          <img src={process.env.PUBLIC_URL + '/images/wave.svg'} alt="" style={{ margin:'0 auto', width:'80%', display:'block', paddingTop:'120px' }} />
         </div>
      </div>
    </div>
  );
}

export default RetirementYears;
